import util from '../../lib/util';
import {workingSet} from './mergeContext';
import store from '../store';
import Actions from '../actions/indexExport';
import {getCurrentUserId} from '../../lib/picos/currentLogin';
import newHRTimestamp from '../../lib/picos/timestamp';
import {findAll} from '../find';
import Lead from '../../entities/lead';
import Matter from '../../entities/matter';
import Invoice from '../../entities/invoice';
import Referral from '../../entities/referral';
import Task from '../../entities/task';
import Document from '../../entities/document';
import Comment from '../../entities/comment';
import Participant from '../../entities/participant';
import RedFlag from '../../entities/redFlag';
import Milestone from '../../entities/milestone';
export function deleteLead(lead: Lead, mergeId?: string) {
let targetImportSource = 'merge';
if (!mergeId) {targetImportSource = 'delete';mergeId = lead.id;}
const _work = workingSet();
store.getState().matters.getMappingFor('leadId', lead.id).filter(matterTemp => matterTemp.status !== 'D').forEach(matterTemp => {
const _matter = ((_work.get('matter:' + matterTemp.id) ?? matterTemp) as Matter).clone();
_matter.status = 'U';
_matter.addedOn = newHRTimestamp();
_matter.addedBy = getCurrentUserId();
_matter.importSource = targetImportSource;
_matter.importId = mergeId;
if (_matter.leadId === lead.id) {
_matter.leadId = null;

}
_work.set('matter:' + _matter.id, _matter);
store.dispatch(Actions.MatterActions.saveMatterQueue(_matter));
});
store.getState().invoices.getMappingFor('leadId', lead.id).filter(invoiceTemp => invoiceTemp.status !== 'D').forEach(invoiceTemp => {
const _invoice = ((_work.get('invoice:' + invoiceTemp.id) ?? invoiceTemp) as Invoice).clone();
_invoice.status = 'U';
_invoice.addedOn = newHRTimestamp();
_invoice.addedBy = getCurrentUserId();
_invoice.importSource = targetImportSource;
_invoice.importId = mergeId;
if (_invoice.leadId === lead.id) {
_invoice.leadId = null;

}
_work.set('invoice:' + _invoice.id, _invoice);
store.dispatch(Actions.InvoiceActions.saveInvoiceQueue(_invoice));
});
store.getState().referrals.getMappingFor('referral', lead.id).filter(referralTemp => referralTemp.status !== 'D').forEach(referralTemp => {
const _referral = ((_work.get('referral:' + referralTemp.id) ?? referralTemp) as Referral).clone();
_referral.status = 'U';
_referral.addedOn = newHRTimestamp();
_referral.addedBy = getCurrentUserId();
_referral.importSource = targetImportSource;
_referral.importId = mergeId;
if (_referral.referral === lead.id) {
_referral.referral = '';

}
_work.set('referral:' + _referral.id, _referral);
store.dispatch(Actions.ReferralActions.saveReferralQueue(_referral));
});


findAll<Task>('tasks').filter(taskTemp => taskTemp.status !== 'D' && taskTemp.hasOwnProperty('tieIns')).filter(taskTemp => !!taskTemp.tieIns?.some(f => {return 'Lead' === f.entity && f.id === lead.id;})).forEach(taskTemp => {
const _task = ((_work.get('task:' + taskTemp.id) ?? taskTemp) as Task).clone();
_task.tieIns = [...(_task.tieIns || [])].filter(f => !('Lead' === f.entity && f.id === lead.id));
_task.status = 'U';
_task.addedOn = newHRTimestamp();
_task.addedBy = getCurrentUserId();
_task.importSource = targetImportSource;
_task.importId = mergeId;
_work.set('task:' + _task.id, _task);
store.dispatch(Actions.TaskActions.saveTaskQueue(_task));
});
lead.status = 'D';
lead.addedOn = newHRTimestamp();
lead.addedBy = getCurrentUserId();
lead.importSource = targetImportSource;
lead.importId = mergeId;
store.dispatch(Actions.LeadActions.removeLeadQueue(lead));
findAll<Document>('documents').filter(documentTemp => documentTemp.entityType === 'lead' && documentTemp.entityId === lead.id && documentTemp.status !== 'D').forEach(documentTemp => {
const _document = ((_work.get('document:' + documentTemp.id) ?? documentTemp) as Document).clone();
_document.status = 'D';
_document.addedOn = newHRTimestamp();
_document.addedBy = getCurrentUserId();
_document.importSource = targetImportSource;
_document.importId = mergeId;
_work.set('document:' + _document.id, _document);
store.dispatch(Actions.DocumentActions.removeDocumentQueue(_document));
});
findAll<Comment>('comments').filter(commentTemp => commentTemp.entityType === 'lead' && commentTemp.entityId === lead.id && commentTemp.status !== 'D').forEach(commentTemp => {
const _comment = ((_work.get('comment:' + commentTemp.id) ?? commentTemp) as Comment).clone();
_comment.status = 'D';
_comment.addedOn = newHRTimestamp();
_comment.addedBy = getCurrentUserId();
_comment.importSource = targetImportSource;
_comment.importId = mergeId;
_work.set('comment:' + _comment.id, _comment);
store.dispatch(Actions.CommentActions.removeCommentQueue(_comment));
});
findAll<Participant>('participants').filter(participantTemp => participantTemp.entityType === 'lead' && participantTemp.entityId === lead.id && participantTemp.status !== 'D').forEach(participantTemp => {
const _participant = ((_work.get('participant:' + participantTemp.id) ?? participantTemp) as Participant).clone();
_participant.status = 'D';
_participant.addedOn = newHRTimestamp();
_participant.addedBy = getCurrentUserId();
_participant.importSource = targetImportSource;
_participant.importId = mergeId;
_work.set('participant:' + _participant.id, _participant);
store.dispatch(Actions.ParticipantActions.removeParticipantQueue(_participant));
});
findAll<RedFlag>('redFlags').filter(redFlagTemp => redFlagTemp.entityType === 'lead' && redFlagTemp.entityId === lead.id && redFlagTemp.status !== 'D').forEach(redFlagTemp => {
const _redFlag = ((_work.get('redFlag:' + redFlagTemp.id) ?? redFlagTemp) as RedFlag).clone();
_redFlag.status = 'D';
_redFlag.addedOn = newHRTimestamp();
_redFlag.addedBy = getCurrentUserId();
_redFlag.importSource = targetImportSource;
_redFlag.importId = mergeId;
_work.set('redFlag:' + _redFlag.id, _redFlag);
store.dispatch(Actions.RedFlagActions.removeRedFlagQueue(_redFlag));
});
findAll<Milestone>('milestones').filter(milestoneTemp => milestoneTemp.entityType === 'lead' && milestoneTemp.entityId === lead.id && milestoneTemp.status !== 'D').forEach(milestoneTemp => {
const _milestone = ((_work.get('milestone:' + milestoneTemp.id) ?? milestoneTemp) as Milestone).clone();
_milestone.status = 'D';
_milestone.addedOn = newHRTimestamp();
_milestone.addedBy = getCurrentUserId();
_milestone.importSource = targetImportSource;
_milestone.importId = mergeId;
_work.set('milestone:' + _milestone.id, _milestone);
store.dispatch(Actions.MilestoneActions.removeMilestoneQueue(_milestone));
});
}
export function replaceLead(lead: Lead, replaceWith: Lead, mergeId?: string) {
let targetImportSource = 'merge';
if (!mergeId) {targetImportSource = 'delete';mergeId = lead.id;}
const _work = workingSet();
store.getState().matters.getMappingFor('leadId', lead.id).filter(matterTemp => matterTemp.status !== 'D').forEach(matterTemp => {
const _matter = ((_work.get('matter:' + matterTemp.id) ?? matterTemp) as Matter).clone();
_matter.status = 'U';
_matter.addedOn = newHRTimestamp();
_matter.addedBy = getCurrentUserId();
_matter.importSource = targetImportSource;
_matter.importId = mergeId;
if (_matter.leadId === lead.id) {
_matter.leadId = replaceWith.id;

}
_work.set('matter:' + _matter.id, _matter);
store.dispatch(Actions.MatterActions.saveMatterQueue(_matter));
});
store.getState().invoices.getMappingFor('leadId', lead.id).filter(invoiceTemp => invoiceTemp.status !== 'D').forEach(invoiceTemp => {
const _invoice = ((_work.get('invoice:' + invoiceTemp.id) ?? invoiceTemp) as Invoice).clone();
_invoice.status = 'U';
_invoice.addedOn = newHRTimestamp();
_invoice.addedBy = getCurrentUserId();
_invoice.importSource = targetImportSource;
_invoice.importId = mergeId;
if (_invoice.leadId === lead.id) {
_invoice.leadId = replaceWith.id;

}
_work.set('invoice:' + _invoice.id, _invoice);
store.dispatch(Actions.InvoiceActions.saveInvoiceQueue(_invoice));
});
store.getState().referrals.getMappingFor('referral', lead.id).filter(referralTemp => referralTemp.status !== 'D').forEach(referralTemp => {
const _referral = ((_work.get('referral:' + referralTemp.id) ?? referralTemp) as Referral).clone();
_referral.status = 'U';
_referral.addedOn = newHRTimestamp();
_referral.addedBy = getCurrentUserId();
_referral.importSource = targetImportSource;
_referral.importId = mergeId;
if (_referral.referral === lead.id) {
_referral.referral = replaceWith.id;

}
_work.set('referral:' + _referral.id, _referral);
store.dispatch(Actions.ReferralActions.saveReferralQueue(_referral));
});


findAll<Task>('tasks').filter(taskTemp => taskTemp.status !== 'D' && taskTemp.hasOwnProperty('tieIns')).filter(taskTemp => !!taskTemp.tieIns?.some(f => {return 'Lead' === f.entity && f.id === lead.id;})).forEach(taskTemp => {
const _task = ((_work.get('task:' + taskTemp.id) ?? taskTemp) as Task).clone();
_task.tieIns = [...(_task.tieIns || [])].map(f => {if ('Lead' === f.entity && f.id === lead.id) {const _f = {...f}; _f.id = replaceWith.id; return _f;} else return f;});
_task.status = 'U';
_task.addedOn = newHRTimestamp();
_task.addedBy = getCurrentUserId();
_task.importSource = targetImportSource;
_task.importId = mergeId;
_work.set('task:' + _task.id, _task);
store.dispatch(Actions.TaskActions.saveTaskQueue(_task));
});
findAll<Document>('documents').filter(documentTemp => documentTemp.entityType === 'lead' && documentTemp.entityId === lead.id && documentTemp.status !== 'D').forEach(documentTemp => {
const _document = ((_work.get('document:' + documentTemp.id) ?? documentTemp) as Document).clone();
_document.entityId = replaceWith.id;
_document.status = 'U';
_document.addedOn = newHRTimestamp();
_document.addedBy = getCurrentUserId();
_document.importSource = targetImportSource;
_document.importId = mergeId;
_work.set('document:' + _document.id, _document);
store.dispatch(Actions.DocumentActions.saveDocumentQueue(_document));
});
findAll<Comment>('comments').filter(commentTemp => commentTemp.entityType === 'lead' && commentTemp.entityId === lead.id && commentTemp.status !== 'D').forEach(commentTemp => {
const _comment = ((_work.get('comment:' + commentTemp.id) ?? commentTemp) as Comment).clone();
_comment.entityId = replaceWith.id;
_comment.status = 'U';
_comment.addedOn = newHRTimestamp();
_comment.addedBy = getCurrentUserId();
_comment.importSource = targetImportSource;
_comment.importId = mergeId;
_work.set('comment:' + _comment.id, _comment);
store.dispatch(Actions.CommentActions.saveCommentQueue(_comment));
});
findAll<Participant>('participants').filter(participantTemp => participantTemp.entityType === 'lead' && participantTemp.entityId === lead.id && participantTemp.status !== 'D').forEach(participantTemp => {
const _participant = ((_work.get('participant:' + participantTemp.id) ?? participantTemp) as Participant).clone();
_participant.entityId = replaceWith.id;
_participant.status = 'U';
_participant.addedOn = newHRTimestamp();
_participant.addedBy = getCurrentUserId();
_participant.importSource = targetImportSource;
_participant.importId = mergeId;
_work.set('participant:' + _participant.id, _participant);
store.dispatch(Actions.ParticipantActions.saveParticipantQueue(_participant));
});
findAll<RedFlag>('redFlags').filter(redFlagTemp => redFlagTemp.entityType === 'lead' && redFlagTemp.entityId === lead.id && redFlagTemp.status !== 'D').forEach(redFlagTemp => {
const _redFlag = ((_work.get('redFlag:' + redFlagTemp.id) ?? redFlagTemp) as RedFlag).clone();
_redFlag.entityId = replaceWith.id;
_redFlag.status = 'U';
_redFlag.addedOn = newHRTimestamp();
_redFlag.addedBy = getCurrentUserId();
_redFlag.importSource = targetImportSource;
_redFlag.importId = mergeId;
_work.set('redFlag:' + _redFlag.id, _redFlag);
store.dispatch(Actions.RedFlagActions.saveRedFlagQueue(_redFlag));
});
findAll<Milestone>('milestones').filter(milestoneTemp => milestoneTemp.entityType === 'lead' && milestoneTemp.entityId === lead.id && milestoneTemp.status !== 'D').forEach(milestoneTemp => {
const _milestone = ((_work.get('milestone:' + milestoneTemp.id) ?? milestoneTemp) as Milestone).clone();
_milestone.entityId = replaceWith.id;
_milestone.status = 'U';
_milestone.addedOn = newHRTimestamp();
_milestone.addedBy = getCurrentUserId();
_milestone.importSource = targetImportSource;
_milestone.importId = mergeId;
_work.set('milestone:' + _milestone.id, _milestone);
store.dispatch(Actions.MilestoneActions.saveMilestoneQueue(_milestone));
});
return lead;
}
export function deleteImpactLead(lead: Lead) {
const impacts: string[] = [];
const state = store.getState();
const matterLeadIdImpact = state.matters.getMappingFor('leadId', lead.id).filter(matter => matter.status !== 'D');
matterLeadIdImpact.forEach(() => impacts.push('matters'));
const invoiceLeadIdImpact = state.invoices.getMappingFor('leadId', lead.id).filter(invoice => invoice.status !== 'D');
invoiceLeadIdImpact.forEach(() => impacts.push('invoices'));
const referralReferralImpact = state.referrals.getMappingFor('referral', lead.id).filter(referral => referral.status !== 'D');
referralReferralImpact.forEach(() => impacts.push('referrals*'));


const taskTieInsImpact = findAll<Task>('tasks').filter(task => task.status !== 'D' && task.hasOwnProperty('tieIns')).filter(task => !!task.tieIns?.some(f => {return 'Lead' === f.entity && f.id === lead.id;}));
taskTieInsImpact.forEach(() => impacts.push('tasks'));
return util.countDistinct(impacts);
}
